import React from 'react';

import {
  ArrayInput,
  minLength,
  required,
  SimpleFormIterator,
  useSourceContext,
} from 'react-admin';
import { Box } from '@mui/material';

import { DateTime } from 'luxon';
import { get } from 'lodash';

import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const PeriodFields = () => {
  const { getSource } = useSourceContext();

  const periodRangeValidation = (_value: string, allValues: unknown): string | undefined => {
    const from = get(allValues, getSource('from')) as string | undefined;
    const to = get(allValues, getSource('to')) as string | undefined;
    if (from && to && DateTime.fromISO(from) > DateTime.fromISO(to)) {
      return 'from date should be before to date';
    }
    return undefined;
  };

  return (
    <RangeFields
      from={(
        <SmartDateInput
          fullWidth
          source="from"
          label="From"
          validate={[required(), isPastDate, periodRangeValidation]}
          helperText={false}
        />
      )}
      to={(
        <SmartDateInput
          fullWidth
          source="to"
          label="To"
          validate={[required(), isPastDate, periodRangeValidation]}
          helperText={false}
        />
      )}
    />
  );
};

const KriReport = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Periods" description="Add one or more periods. Each period includes data from 'From' date up to and including 'To' date. At least one period is required.">
      <ArrayInput source="report.periods" label="" helperText={false} validate={[required(), minLength(1)]}>
        <SimpleFormIterator
          inline
          disableReordering
          fullWidth
          sx={{
            '& .RaSimpleFormIterator-line': {
              borderBottom: 'none',
              '& .RaSimpleFormIterator-inline': {
                rowGap: '1em',
              },
            },
          }}
        >
          <PeriodFields />
        </SimpleFormIterator>
      </ArrayInput>
    </FieldBox>
  </Box>
);

export default KriReport;
